const value = {
    all: 'All',
    published: 'Published',
    notPublished: 'Not published',
  };

export default value;
